import { FilterType } from '../../grid/utils/filter/filter.utils';

export enum CalendarFiltersGroups {
  Advanced = 'advanced',
  Grid = 'grid'
}

export class CalendarFilter<T = any> {
  public readonly timestamp: number;
  constructor(
    public readonly name: string,
    public readonly label: string,
    public readonly type: FilterType,
    public readonly model: T,
    public readonly group?: CalendarFiltersGroups
  ) {
    this.timestamp = new Date().getTime();
  }
}

export interface CalendarFiltersState {
  [key: string]: CalendarFilter;
}
